<div class="modal-body session-info">
  <div class="text-center leave-class-box">
    <img src="assets/img/subject-icons/{{data?.subject?.toLowerCase()}}-icon.svg" alt="" class="large-icon mb-3">
    <span class="subject-name">{{data.subject | uppercase }}</span>
    <h4 class="mb-2"><span>{{data?.title}}</span></h4>
    <span class="tchr-name mb-3">By {{data?.teacher?.name}}</span>
    <p>{{data?.schedule?.startTime | date: 'd MMM, YYYY'}} • {{data?.schedule?.startTime | date: 'shortTime'}} - {{data?.schedule?.endTime | date: 'shortTime'}}</p>
    <button type="button" class="btn-link btn-block mt-2 skip-btn" (click)="closeSessionInfor()">Close</button>
  </div>
</div>